export default () => {

    const btn = document.querySelector('[data-signup]');
    const modal = document.querySelector('[data-modal]');
    const close = document.querySelector('[data-close]');
    // const form = document.querySelector('[data-subscribe-form]');

    if (btn) {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            modal.classList.add('active');
            return false;
        });
    }

    if (close) {
        close.addEventListener('click', (e) => {
            e.preventDefault();
            modal.classList.remove('active');
            return false;
        });
    }

    // form.addEventListener('submit', (e) => {
    //     e.preventDefault();
    //
    //     const xhr = new XMLHttpRequest();
    //     const data = new FormData(form);
    //     xhr.open('POST', form.getAttribute('action'), true);
    //
    //     xhr.onload = function() {
    //         if (xhr.readyState === 4 && xhr.status === 200) {
    //             modal.classList.remove('active');
    //         }
    //     }
    //     xhr.send(data);
    //
    //     return false;
    // })

}
